
function WhiteCloseLight() {
	return (
		<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M19 5.5L5 19.5" stroke="white" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
			<path d="M19 19.5L5 5.5" stroke="white" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
		</svg>
	);
}

export default WhiteCloseLight;
